import {
  Button,
  Container,
  Header,
  Multiselect,
  SpaceBetween
} from '@cloudscape-design/components';
import { useContext, useEffect, useState } from 'react';
import { DocumentContext } from '../../context/documentContext';
import { getOwnership } from '../../helpers/getOwnership';
import { DocumentViewerFiltered } from '../FilteredDocumentViewer';
import { OptionDefinition } from '@cloudscape-design/components/internal/components/option/interfaces';
interface TopciProps {
  setPageType: (arg: string) => void;
  setShowDetail: (arg: boolean) => void;
  setShowOverview: (arg: boolean) => void;
  setShowSynopsis: () => void;
}

export const OwnershipOverview = (props: TopciProps) => {
  const { sentences } = useContext(DocumentContext);
  const [localPageType, setLocalPageType] = useState<string>('');
  const [filteringValue, setFilteringValue] = useState<OptionDefinition[]>([]);
  const [selectionOptions, setSelectionOptions] = useState<OptionDefinition[]>(
    []
  );

  useEffect(() => {
    if (sentences.length > 0) {
      const ownershipList = getOwnership(sentences);
      console.log('ownership list', ownershipList);
      if (ownershipList.length > 0) {
        const tempList = ownershipList.reduce(
          (acc, curr) => {
            acc.optionList.push({ label: curr, value: curr });
            return acc;
          },
          { optionList: [] } as {
            optionList: { label: string; value: string }[];
          }
        );
        setSelectionOptions(tempList.optionList);
        setFilteringValue(tempList.optionList);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sentences]);

  useEffect(() => {
    const list = filteringValue.map((ele) => ele.label);
    setLocalPageType(`ownership@${list.join(':::')}`);
  }, [filteringValue]);

  return (
    <>
      <Container
        header={
          <Header
            actions={
              <SpaceBetween direction="horizontal" size="s">
                <Button onClick={() => props.setShowSynopsis()}>
                  Back to Synopsis
                </Button>
              </SpaceBetween>
            }
          >
            <SpaceBetween size={'s'}>
              <h1 style={{ margin: '0 0 ' }}>Document Synopsis</h1>
              <h6 style={{ margin: '0 0 ' }}>
                OBLIGATIONS & EXPECTATIONS ASSIGNMENT
              </h6>
              {/* <p style={{ margin: '0 0 ', fontSize: '12px' }}>
                LOUIS TO GIVE ME BETTER TEXT FOR HERE !!!!!!!!
              </p> */}
            </SpaceBetween>
          </Header>
        }
      >
        <div style={{ height: '80vh', overflowY: 'scroll' }}>
          <SpaceBetween direction="vertical" size="s">
            <Multiselect
              placeholder="Please select assignments"
              selectedOptions={filteringValue}
              options={selectionOptions}
              onChange={({ detail }) => {
                console.log('detail', detail);
                setFilteringValue([...detail.selectedOptions]);
              }}
            />
            <DocumentViewerFiltered
              pageIdentifier={localPageType}
              setShowSynopsis={props.setShowSynopsis}
            />
          </SpaceBetween>
        </div>
      </Container>
    </>
  );
};
